import API from './axios.js';


export const getNotification = () =>API.get(`notifications`);
export const updateUnseenNotification = (id) =>API.patch(`notifications/status/${id}`);

export const getAllBubbleData = () =>API.get(`notifications/bubble`);